<template>
	<v-table density="compact">
		<thead>
			<tr>
				<th
					v-for="entity in entities"
					:key="entity.key"
					class="text-left ao-p2-medium"
				>
					{{ entity.title }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr
				v-for="item in items"
				:key="item.id"
			>
				<td
					v-for="entity in entities"
					class="ao-p2-regular"
				>
					<template v-if="entity.type === 'status'">
						<div
							:class="[
								$style.status,
								item[entity.key] && $style[`status--${item[entity.key].value}`],
								'ao-p2-regular px-1 text-no-wrap rounded',
							]"
						>
							{{ item[entity.key] && item[entity.key].title }}
						</div>
					</template>
					<template v-if="entity.type === 'bar'">
						<passport-limit-progress-bar
							:limit="item[entity.key].limit"
							:current="item[entity.key].current"
							:total="item[entity.key].total"
						/>
					</template>
					<tempalte v-if="!entity.type">
						<span class="ao-p2-regular">{{ item[entity.key] }}</span>
					</tempalte>
				</td>
			</tr>
			<tr/>
		</tbody>
	</v-table>
	<div :class="$style.footer">Всего: {{ items ? items.length : '' }}</div>
</template>

<script>
export default {
	name: 'PassportTable',
	props: {
		entities: {
			type: Array,
			default: () => [],
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
}
</script>

<style module lang="scss">
.status {
	width: fit-content;

	&--new {
		background: #ddf0e3;
	}
	&--progress {
		background: #faf4e6;
	}
	&--ended {
		background: #faeceb;
	}
	&--closed {
		background: #f3f3f4;
	}
}

.footer {
	width: 100%;
	padding: 12px;

	border-top: 1px solid #e6eef3;

	font-size: 14px;
}
</style>
